import { ListCollaborator } from './ListCollaborator';
import { ListView } from './ListView';

export enum ListViewColumnDataType {
    // Core Primatives
    SHORT_TEXT = 'Short Text',
    LONG_TEXT = 'Long Text',
    NUMBER = 'Number',
    DATE = 'Date',
    BOOLEAN = 'Boolean',
    SELECT = 'Select',
    MULTISELECT = 'Multi-Select',
    // Rich Primatives
    CURRENCY = 'Currency', // (ISO-4217)
    PERCENTAGE = 'Percentage',
    MONTH = 'Month',
    QUARTER = 'Quarter',
    YEAR = 'Year',
    DATE_RANGE = 'Date Range',
    URL = 'URL',
    EMAIL = 'Email',
    PHONE = 'Phone Number',
    ADDRESS = 'Address',
    JSON = 'Key Value (JSON)',
    // Relational Types
    RELATION = 'Relation', // One to One
    MULTIRELATION = 'Multi-Relation', // Many to Many
    // File Types
    ATTACHMENT = 'Attachment',
    // Computed Types
    FORMULA = 'Formula',
    LOOKUP = 'Lookup',
    AGGREGATION = 'Aggregation', // e.g. SUM, AVG, MIN, MAX, COUNT, etc.
    // Workflows
    STATUS = 'Status', // Select
    PROGRESS = 'Progress', // Select
    // AI / System Generated
    AI_SUMMARY = 'Summary (AI)',
    AI_CLASSIFICATION = 'Classification (AI)',
    // Misc
    OBJECT = 'Object',
    EMBED = 'Embed',
}

export interface ListViewColumn {
    id: string;
    owner: ListCollaborator;
    view: ListView;
    dataType: ListViewColumnDataType;
    key: string;
    label: string;
    isHidden: boolean;
    order: number;
    createdAt: Date;
    updatedAt: Date;
}
